// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ServerErrorSummary, IServerErrorSummary } from "./ServerErrorSummary.gen";

export interface IServerErrorPaginatedResult {
	data: IServerErrorSummary[] | undefined;

	totalOccurrences: number;

	totalHourlyRate: number;

	totalCount: number;

	page: number;

	pageSize: number;

	totalPages: number;

	$type?: string | undefined;
}
export class ServerErrorPaginatedResult {
	constructor(data?: IServerErrorPaginatedResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new ServerErrorSummary(d)) : [];
	}

	data: ServerErrorSummary[] | undefined = [];

	totalOccurrences: number = 0;

	totalHourlyRate: number = 0;

	totalCount: number = 0;

	page: number = 0;

	pageSize: number = 0;

	totalPages: number = 0;

	static $type: string = "CoreApi.Models.Pagination.ServerErrorPaginatedResult, ";
	$type?: string | undefined = ServerErrorPaginatedResult.$type;
}

